import React from "react"
import { ButtonParser } from "components/button/ButtonParser"
import { Content } from "components/content/Content"
import type { ButtonElements } from "_types/Button"
import "./content-block.module.scss"

interface TextContentBlockProps {
  alternate_background_color?: boolean
  buttons?: ButtonElements[]
  eyebrow_text: string | null
  heading: string | null
  sub_heading?: string
  text?: string | null
  style_lists_as_grid?: boolean
}

export const TextContentBlock = ({
  alternate_background_color,
  buttons,
  eyebrow_text,
  heading,
  sub_heading,
  text,
  style_lists_as_grid = false,
}: TextContentBlockProps) => {
  const isContentEmpty = text === "" ? true : false
  const isSubHeadingEmpty = !sub_heading || sub_heading === null

  const alternateBackground = alternate_background_color
    ? "alternate-background-color"
    : ""

  return (
    <section
      className={`text-content-block u-content-block-padding ${alternateBackground} u-clearfix`}
    >
      <div className="fr-container">
        {(eyebrow_text || heading || !isSubHeadingEmpty) && (
          <div className={`text-content-block`}>
            {eyebrow_text && <p className={`eyebrow-text`}>{eyebrow_text}</p>}
            {heading && <h2>{heading}</h2>}
            {!isSubHeadingEmpty && <h3>{sub_heading}</h3>}
          </div>
        )}
        {text && text.length > 0 && !isContentEmpty && (
          <div className="text-content-block__content">
            <Content content={text} styleListsAsGrid={style_lists_as_grid} />
          </div>
        )}
        {buttons && buttons.length > 0 && (
          <div className="content-block-buttons">
            <ButtonParser buttons={buttons} />
          </div>
        )}
      </div>
    </section>
  )
}
